module.exports = __webpack_public_path__ + "assets/img/ICI-UK-Content-Marketing.1e5e07d3.webp";